/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLast_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_viewer" | "ReplyListContainerLastFlattened_viewer">;
    readonly " $refType": "ReplyListContainerLast_viewer";
};
export type ReplyListContainerLast_viewer$data = ReplyListContainerLast_viewer;
export type ReplyListContainerLast_viewer$key = {
    readonly " $data"?: ReplyListContainerLast_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLast_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "flattenReplies"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLast_viewer",
    "selections": [
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LocalReplyListContainer_viewer"
                }
            ]
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReplyListContainerLastFlattened_viewer"
                }
            ]
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'adc94f962e3fe1f4d66a0abfc50afde8';
export default node;
